import React from "react";

export default function SizeIcon(props: any) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 -0.000244141V22.9998H2L2.00171 3.41646L21.293 22.7068L22.707 21.2928L3.414 2.00076H23V-0.000244141H0Z"
        fill="black"
      />
      <path
        d="M36.9999 2.00076V-0.000244141H59.9999V22.9998H57.9999V3.41476L38.7069 22.7068L37.2929 21.2928L56.5859 2.00076H36.9999Z"
        fill="black"
      />
      <path
        d="M0 36.9996V59.9996H23V58.0006H3.414L22.707 38.7066L21.293 37.2926L2 56.5866V36.9996H0Z"
        fill="black"
      />
      <path
        d="M57.9996 36.9996H60.0006V59.9996H36.9996V58.0006H56.5856L37.2936 38.7066L38.7076 37.2926L57.9996 56.5866V36.9996Z"
        fill="black"
      />
    </svg>
  );
}
